import httpClient from '../../../../api/httpClient';
import API_CONFIG from '../../../../config/api.config';
import { 
  Department, 
  DepartmentFormData, 
  DepartmentListResponse, 
  DepartmentFilterParams,
  DepartmentStatusUpdate 
} from '../types/department.types';

const ENDPOINT = API_CONFIG.ENDPOINTS.DEPARTMENTS;

export const departmentApi = {
  /**
   * Get paginated list of departments with optional filters
   */
  getAll: async (params?: DepartmentFilterParams): Promise<DepartmentListResponse> => {
    const response = await httpClient.get<Department[]>(ENDPOINT, { params });
    // Transform the array response into a DepartmentListResponse object
    return {
      data: response.data,
      total: response.data.length, // This might need to be updated if you have server-side pagination
      page: params?.page || 1,
      limit: params?.limit || 10,
      totalPages: Math.ceil(response.data.length / (params?.limit || 10))
    };
  },

  /**
   * Get a single department by ID
   */
  getById: async (id: string): Promise<Department> => {
    const response = await httpClient.get<Department>(`${ENDPOINT}/${id}`);
    return response.data;
  },

  /**
   * Create a new department
   */
  create: async (department: DepartmentFormData): Promise<Department> => {
    const response = await httpClient.post<Department>(ENDPOINT, department);
    return response.data;
  },

  /**
   * Update an existing department
   */
  update: async (id: string, department: Partial<DepartmentFormData>): Promise<Department> => {
    const response = await httpClient.patch<Department>(`${ENDPOINT}/${id}`, department);
    return response.data;
  },

  /**
   * Delete a department
   */
  delete: async (id: string): Promise<void> => {
    await httpClient.delete(`${ENDPOINT}/${id}`);
  },

  /**
   * Update department status
   */
  updateStatus: async (id: string, status: DepartmentStatusUpdate): Promise<Department> => {
    const response = await httpClient.patch<Department>(`${ENDPOINT}/${id}/status`, status);
    return response.data;
  }
};
